const envKey = '__RSN_ENVIRONMENT__';

let envObject: Record<string, unknown> | null = null;

function getEnv(key: string) {
    if (envObject === null) {
        envObject = getEnvObject();
    }
    const val = envObject[key];
    if (typeof val !== 'string' || val.length === 0) {
        throw new Error(`Could not read env key "${key}", got ${JSON.stringify(val)}`);
    }
    return val;
}

function getEnvObject() {
    if (envKey in window && window[envKey] && typeof window[envKey] === 'object') {
        return window[envKey] satisfies object as Record<string, unknown>;
    } else {
        throw new Error(`Could not get env, ${envKey} is "${typeof window[envKey as any]}"`);
    }
}

/**
 * Should never throw, because it's needed to init Sentry
 */
export function readAppEnv(): string | undefined {
    const env = (window as any)[envKey]?.APP_ENV;
    console.info('[APP_ENV]', env);
    return env;
}

/**
 * Each property is lazy to delay access in case Sentry didn't have time to init.
 */
export const env = {
    get APP_ENV() {
        return getEnv('APP_ENV');
    },
    get API_URL() {
        return getEnv('API_URL');
    },
    get WEB_URL() {
        return getEnv('WEB_URL');
    },
    get APP_URL() {
        return getEnv('APP_URL');
    },
    get KYC_URL() {
        return getEnv('KYC_URL');
    },
    get STRIPE_TOKEN() {
        return getEnv('STRIPE_TOKEN');
    },
    get TURNSTILE_SITEKEY() {
        return getEnv('TURNSTILE_SITEKEY');
    },
    get INTERCOM_APP_ID() {
        return getEnv('INTERCOM_APP_ID');
    },
    get IOS_SHELL_VERSION_CRUCIAL() {
        return getEnv('IOS_SHELL_VERSION_CRUCIAL');
    },
    get IOS_SHELL_VERSION_OPTIMAL() {
        return getEnv('IOS_SHELL_VERSION_OPTIMAL');
    },
    get ANDROID_SHELL_VERSION_CRUCIAL() {
        return getEnv('ANDROID_SHELL_VERSION_CRUCIAL');
    },
    get ANDROID_SHELL_VERSION_OPTIMAL() {
        return getEnv('ANDROID_SHELL_VERSION_OPTIMAL');
    },
};
